import { ShareType } from '@modeso/aumico-lib-core-fe';

export interface CreateShareDto {
    entityId: string;
    emails: string[];
    message: string;
    type: ShareType;
}
